
export enum RateDiscountSourceCd {
	DPRT = 'DPRT',
	DPWT = 'DPWT',
	DSTD = 'DSTD',
	DTLP = 'DTLP',
	LNFT = 'LNFT'}

